import * as utils from '@utils/form';

export const FORM_FIELD = {
  TAG: {
    name: 'tag',
    rules: [{ required: true, message: 'A content tag is required' }],
    serialize: utils.relatedEntitySerializer,
  },
  MORE_NEWS_LINK: {
    name: 'moreNewsLink',
    label: 'More news link:',
    placeholder: 'Enter a more news link',
    rules: [{ type: 'url', message: "Doesn't look like a valid URL" }],
  },
};
export const FORM_FIELDS = Object.values(FORM_FIELD);

export const INITIAL_VALUES = {};
